module.exports = __webpack_public_path__ + "static/media/Default_Game_Tile_Web_Large@3x.fa87f215.png";